<template>
    <div>
        <editor :init="config" v-bind="$attrs" v-on="$listeners"></editor>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
    components: { Editor },
    props: {
        height: {
            type: Number,
            default: 500,
        },
        defPlugins: {
            type: String,
            required: false,
            default: 'advlist autolink lists print preview searchreplace visualblocks fullscreen paste code',
        },
        defToolbar: {
            type: String,
            required: false,
            default:
                'undo redo | formatselect | bold italic backcolor code| \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | variables | preview',
        },
        hideMenubar: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            config: {
                height: this.height,
                header: true,
                statusbar: false,
                plugins: this.defPlugins,
                toolbar: this.defToolbar,
                menubar: !this.hideMenubar,
                browser_spellcheck: true,
            },
        };
    },
};
</script>

<style scoped></style>
